import React from 'react';
import { Quote, Star } from 'lucide-react';
import { testimonials } from '../mock';
import { Card, CardContent } from './ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';

const TestimonialsSection = () => {
  const clientTestimonials = testimonials.filter((t) => t.type === 'client');
  const brandTestimonials = testimonials.filter((t) => t.type === 'brand');

  const TestimonialCard = ({ testimonial }) => (
    <Card className="bg-gradient-to-br from-gray-900 to-black border-gray-800 hover:border-[#00ff41] transition-all duration-300 h-full">
      <CardContent className="p-6">
        <div className="flex items-start gap-4 mb-4">
          <img
            src={testimonial.image}
            alt={testimonial.name}
            className="w-16 h-16 rounded-full object-cover border-2 border-[#00ff41]"
          />
          <div className="flex-1">
            <h4 className="text-white font-bold text-lg">{testimonial.name}</h4>
            <p className="text-gray-400 text-sm">{testimonial.role}</p>
            <div className="flex gap-1 mt-2">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={14} className="text-[#ff6b35] fill-[#ff6b35]" />
              ))}
            </div>
          </div>
          <Quote className="text-[#00ff41]/20" size={32} />
        </div>
        <p className="text-gray-300 leading-relaxed mb-4">{testimonial.content}</p>
        <div className="pt-4 border-t border-gray-800">
          <span className="inline-block px-3 py-1 bg-[#00ff41]/10 text-[#00ff41] text-sm font-bold rounded-full">
            {testimonial.result}
          </span>
        </div>
      </CardContent>
    </Card>
  );

  return (
    <section id="testimonials" className="bg-gradient-to-b from-[#1a1a1a] to-[#0a0a0a] py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block mb-4 px-4 py-2 bg-[#ff6b35]/10 border border-[#ff6b35]/30 rounded-full">
            <span className="text-[#ff6b35] font-semibold text-sm tracking-wider uppercase">
              Results
            </span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-black text-white mb-4">
            Proven Results, Real Impact
          </h2>
          <p className="text-xl text-gray-400 max-w-2xl mx-auto">
            Transforming lives and delivering ROI for brands
          </p>
        </div>

        <Tabs defaultValue="clients" className="w-full">
          <TabsList className="grid w-full max-w-md mx-auto grid-cols-2 mb-12 bg-gray-900 border border-gray-800">
            <TabsTrigger
              value="clients"
              className="data-[state=active]:bg-[#00ff41] data-[state=active]:text-black font-bold"
            >
              Client Transformations
            </TabsTrigger>
            <TabsTrigger
              value="brands"
              className="data-[state=active]:bg-[#00ff41] data-[state=active]:text-black font-bold"
            >
              Brand Results
            </TabsTrigger>
          </TabsList>

          <TabsContent value="clients" className="mt-0">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {clientTestimonials.map((testimonial) => (
                <TestimonialCard key={testimonial.id} testimonial={testimonial} />
              ))}
            </div>
          </TabsContent>

          <TabsContent value="brands" className="mt-0">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {brandTestimonials.map((testimonial) => (
                <TestimonialCard key={testimonial.id} testimonial={testimonial} />
              ))}
            </div>
          </TabsContent>
        </Tabs>
      </div>
    </section>
  );
};

export default TestimonialsSection;
